var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_main"},[_c('Error',{staticClass:"error",attrs:{"remark":_vm.remark || _vm.$t('error.ErrorTip')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }